import { useNavigate, useParams } from 'react-router-dom'

export default function PacketPage() {
  const { applicationId } = useParams()
  const navigate = useNavigate()

  return (
    <div className='w-full min-h-screen overflow-y-auto flex flex-col p-6 transition-colors duration-300'>
      <div className='w-full max-w-4xl m-auto border border-gray-200 dark:border-slate-700 rounded-xl p-6 sm:p-8 shadow-lg bg-white dark:bg-slate-800 transition-colors duration-300'>
        <h1 className='text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white text-center mb-6 sm:mb-8'>Download Your Packet</h1>
        <ul className='list-disc ml-6 space-y-5 text-gray-700 dark:text-slate-300'>
          <li>
            <strong className='text-base sm:text-lg text-gray-900 dark:text-white'>Print Your Documents:</strong>
            <p className='mt-1 text-sm sm:text-base'>Please ensure all pages are printed single-sided. When mailing your documents, attach the shipping label to the front of the package.</p>
            <ul className='list-disc ml-6 mt-2 text-sm text-gray-600 dark:text-slate-400'>
              <li>If you do not have access to a printer, you may print your documents at a local UPS store.</li>
            </ul>
          </li>
          <li>
            <strong className='text-base sm:text-lg text-gray-900 dark:text-white'>Sign Your Paperwork:</strong>
            <p className='mt-1 text-sm sm:text-base'>Make sure Form 8822-B is completed correctly and wet-signed in the required fields.</p>
          </li>
          <li>
            <strong className='text-base sm:text-lg text-gray-900 dark:text-white'>Prepare Your Mailing:</strong>
            <p className='mt-1 text-sm sm:text-base'>Place Form 8822-B in a secure envelope.</p>
            <ul className='list-disc ml-6 mt-2 text-sm text-gray-600 dark:text-slate-400'>
              <li>For tracking purposes, please attach your Shipping Label provided on page 3 of these instructions, to the outside of the envelope.</li>
            </ul>
          </li>
          <li>
            <strong className='text-base sm:text-lg text-gray-900 dark:text-white'>Mail Your Documents:</strong>
            <p className='mt-1 text-sm sm:text-base'>Place your wet-signed paperwork in a secure envelope with the shipping label attached, and take it to your local UPS store to mail.</p>
          </li>
        </ul>
        <div className='mt-10'>
          <button
            onClick={() => navigate(`/applications/${applicationId}/packet/shipping-label`)}
            className='w-full px-6 py-4 bg-ertc-primary text-white font-bold text-lg rounded-lg hover:bg-opacity-90 transition-all cursor-pointer'
          >
            Download Packet
          </button>
        </div>
      </div>
    </div>
  )
}